import { useStore } from './useStore';
import { stores } from '../stores';
import { filterAvailableCampaigns } from '../services/bonuses/bonus';

export const useAvailablePromotions = () => {
    const [promotions] = useStore(stores.promotions);

    return filterAvailableCampaigns(promotions);
};
